import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, OverlayTrigger, Popover, Tooltip, Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import 'react-table/react-table.css';
import { adminLabels } from 'redux/constant/admin-label-constant';
import ReactTable from "react-table";
import { getTestimonials } from '../../../redux/actions/testimonials';
import { testimonialService } from '../../../services/testimonials';
import EditTestimonialForm from './EditTestimonialForm';
import { savePagination, getSavedPagination } from '../../../helper/helperFunctions';
const queryString = require('query-string');

class TestimonialListPage extends Component {
  constructor(props) {
    super(props);
    const { savedPage, savedPageSize } = getSavedPagination("testimonial");
    const parsed = queryString.parse(window.location.search);
    this.state = {
      editModalDestination: this.props.editModalDestination,
      sorted: '',
      filtered: '',
      savedPage: parsed.restore_page ? savedPage : 0,
      savedPageSize: parsed.restore_page ? savedPageSize : 10,
      is_active: '1',
      selectedId: null,
      brand_id: null,
      selectedBrand: null
    };
  };
  
 	componentDidMount() {
    const { savedPage, savedPageSize ,selectedBrand, pageSize, sorted, filtered } = this.state;
    this.props.getTestimonials(selectedBrand, savedPage + 1, savedPageSize  , sorted, filtered, true);
	}
  paginationCall = () => {
    const { selectedBrand, pageSize, sorted, filtered, savedPage } = this.state;
    this.props.getTestimonials(selectedBrand, savedPage + 1, pageSize, sorted, filtered, true);
  };

  onFetchData = (state) => {
    savePagination("testimonial", state.page, state.pageSize);
    this.setState({
			savedPage: state.page,
			savedPageSize: state.pageSize
		})
    const sort = state.sorted.length === 0 ? '' : `${state.sorted[0].id},desc:${state.sorted[0].desc}`;
    const filter = state.filtered;

    this.setState({
      page: state.page + 1,
      pageSize: state.pageSize,
      sorted: sort,
      filtered: filter
    }, () => {
      this.paginationCall();
    });
  };

  handleupdateTestimonialStatus = testimonialId => (e) => {
    testimonialService.updateTestimonialStatus(testimonialId, {
      is_active: e.target.checked
    }).then(response => {
      this.paginationCall(); // now properly uses current table state
    });
  };

  closeEditModalDestination = () =>{
		this.setState({editModalDestination:false});
	}

  
  render() {
    const { testimonails, pages, adminType, loading } = this.props;
    const { filtered } = this.state;
    const columns = [
      {
        Header: "Testimonial Listing",
        headerClassName: 'headerPagination',
        columns: [
          {
            Header: "Group Name/Festival Name",
            accessor: "company",
            className: "action-center"
          },
          {
            Header: "Testimonial",
            accessor: "description",
            className: "action-center"
          },
          {
            Header: "Author",
            accessor: "author",
            className: "action-center"
          },
          {
              Header: "Submitted Date",
              accessor: "createdAtString",
              className: "action-center"
          },
          {
            Header: "Status",
            accessor: "id",
            Cell: ({ row, original}) => (
              <label className="container-check">
                &nbsp;
                <input type="checkbox" name="is_active" className="checkbox" value={original.is_active ? true : false} onChange={this.handleupdateTestimonialStatus(original.id)} checked={original.is_active ? true : false}
                  readOnly={true} /><span className="checkmark" style={{left: 'auto'}}></span>
              </label>
            ),
          
            className: "action-center",
            sortable: false
          },
          {
            Header: "Actions",
            accessor: "id",
            Cell: ({ value }) => (
              <div>
                {/* <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{adminType ==='company' ? 'Edit Testimonial' : adminLabels.DONT_ALLOW}</Popover>}> */}
                  <span>
                    {
                      adminType ==='company' &&
                      // <button type='button' onClick={() => { this.setState({ editModalDestination: !this.state.editModalDestination, selectedId: value}) }}><i className={adminType ==='company'?"fa fa-pencil":"fa fa-eye"} /></button>
                      <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Testimonial {adminType ==='company'?'edit':'view'}</Tooltip>}>
                        <a onClick={() => { this.setState({ editModalDestination: !this.state.editModalDestination, selectedId: value}) }} className="action-button-size"><i className={adminType ==='company'?"fa fa-pencil":"fa fa-eye"} /></a>
                      </OverlayTrigger>
                    }
                    {
                      adminType !=='company' &&
                      <button type='button' className="editIcon orderDetailsAction button_disabled" >&nbsp;</button>
                    }
                  </span>
                {/* </OverlayTrigger> */}
              </div>
            ),
            className: "action-center",
            sortable: false
          }
        ]
      }
    ];
    
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableResponsive
                title="Testimonials List"
                content={
                  <div>
                    <Grid fluid>
                      <Row>
                        <Col md={12}>
                          {/* <div className="secHeading">
                            Testimonials List
                          </div> */}
                        </Col>
                        <ReactTable                 
                          data={testimonails.data}
                          pages={pages} 
                          loading = {loading}
                          columns={columns}
                          filtered={filtered}
                          page={this.state.savedPage}
                          pageSize={this.state.savedPageSize}
                          className="striped hover"
                          pageData = {this.paginationCall}
                          manual
                          onFetchData={this.onFetchData}
                        />
                      </Row>
                    </Grid>
                  </div>
                } />
            </Col>
          </Row>
        </Grid>
        {
          this.state.editModalDestination &&
          <Modal bsSize="lg" backdrop={'static'} show={this.state.editModalDestination} id="" onHide={this.closeEditModalDestination} aria-labelledby="ModalHeader" className="" >
              <Modal.Header closeButton>
                  <Modal.Title id='ModalHeader' className="headerTitle">Edit Testimonial</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  {/* <div className="container table-responsive mt-xlg"> */}
                      <EditTestimonialForm id={this.state.selectedId} paginationCall={this.paginationCall} closeModal={this.closeEditModalDestination}/>
                  {/* </div> */}
              </Modal.Body>
          </Modal>
          
        }
      </div>
    );
  };
};

const mapDispatchToProps = dispatch => {
  return ({
    getTestimonials: (brand_id, page, pageSize, sort, filter, is_admin) => { dispatch(getTestimonials(brand_id, page, pageSize, sort, filter, is_admin)) }
  });
};

function mapStateToProps(state) {
    const { testimonails, pages, perPage, current_page, loading } = state.testimonialReducer;
    const { adminType, userAdmin } = state.adminReducer;
  return {
    testimonails, pages, perPage, current_page, loading, adminType, userAdmin 
  };
};

const TestimonialList = connect(mapStateToProps, mapDispatchToProps)(TestimonialListPage);
export default TestimonialList;



// WEBPACK FOOTER //
// ./src/components/Admin/Testimonial/TestimonialList.jsx